<app-title [title]="'my-vocabulary.tabs.learned' | customLocale">
  <ng-container side>
    <p class="learned-count">{{ 'my-vocabulary.words' | customLocale}}: 323</p>
  </ng-container>
</app-title>

<app-vocabulary-card [page]="'learned'"></app-vocabulary-card>